import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography, Button } from '@material-ui/core/';
import Page from '~/components/Page';
import * as Sentry from '@sentry/react';

export default ChowbusErrorBoundary;

function ChowbusErrorBoundary({ children }) {
  return <Sentry.ErrorBoundary fallback={ChowbusErrorDisplay}>{children}</Sentry.ErrorBoundary>;
}

function ChowbusErrorDisplay() {
  return (
    <Page name='error'>
      <Grid
        container
        direction='column'
        justify='center'
        alignItems='center'
        style={{ minHeight: '80vh' }}>
        <Typography variant='h5' align='center'>
          We're sorry - Something has gone wrong. Our team has been notified.
        </Typography>
        <Grid item sm={4} xs={10}>
          <Grid container direction='column' justify='center' alignItems='center'>
            <Button color='primary' onClick={() => window.location.reload(false)}>
              Reload the page
            </Button>
            <Button color='primary' onClick={() => (window.location = '/')}>
              Return Home
            </Button>
            <Button onClick={() => Sentry.showReportDialog()}>Show error dialog</Button>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
}
